import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const EuroIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 18.09 18.01" {...props}>
    <path
      id="Tracé_11999"
      data-name="Tracé 11999"
      d="M11.25,0A9,9,0,0,0,2.64,6.37h-2a.66.66,0,0,0,0,1.32H2.34a8.92,8.92,0,0,0,0,2.63H.64A.68.68,0,0,0,0,11a.67.67,0,0,0,.69.63h2A9,9,0,0,0,11.26,18,8.92,8.92,0,0,0,17.87,15a.66.66,0,0,0,.06-.93A.65.65,0,0,0,17,14a.17.17,0,0,0-.06.06c-1.62,1.62-3.14,2.66-5.68,2.66A7.67,7.67,0,0,1,4,11.64h7.66a.66.66,0,1,0,0-1.32h-8a7.74,7.74,0,0,1,0-2.63h8a.66.66,0,0,0,0-1.32H4a7.68,7.68,0,0,1,7.23-5A7.38,7.38,0,0,1,16.93,4a.66.66,0,0,0,.93.07.65.65,0,0,0,.07-.93l-.06-.06A8.94,8.94,0,0,0,11.25,0Z"
    />
  </SvgIcon>
));

export default React.memo(EuroIcon);
